import React, { useRef } from 'react';
import { Animated, Easing } from 'react-native';
import { useFocusEffect } from '@react-navigation/native';

function AnimatedScreen({ children, fromLeft = true }: { children: React.ReactNode, fromLeft?:boolean }) {
  const opacity = useRef(new Animated.Value(0)).current;
  const translateX = useRef(new Animated.Value(fromLeft ? -200 : 200)).current;

  useFocusEffect(
    React.useCallback(() => {
      Animated.parallel([
        Animated.timing(opacity, {
          toValue: 1,
          duration: 300,
          easing: Easing.out(Easing.ease),
          useNativeDriver: true,
        }),
        Animated.timing(translateX, {
          toValue: 0,
          duration: 300,
          easing: Easing.out(Easing.ease),
          useNativeDriver: true,
        }),
      ]).start();

      return () => {
        opacity.setValue(0);
        translateX.setValue(fromLeft ? -200 : 200);
      };
    }, [opacity, translateX])
  );

  return (
    <Animated.View
      style={{
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        opacity: opacity,
        transform: [{ translateX }],
      }}
    >
      {children}
    </Animated.View>
  );
}
export default AnimatedScreen;